import { IonHeader, IonToolbar } from "@ionic/react";
import React from "react";

interface ToolbarSearchBarStatsProps {
}

const options = [
    { value: 'Stats', label: 'Lifty AI' }
]

const ToolbarSearchBarStats: React.FC<ToolbarSearchBarStatsProps> = ({ }) => {

    const [segmentValue, setSegmentValue] = React.useState('Stats');

    const handleSegmentChange = (segement: string) => {
        console.log("Segment Changed: " + segement);
        setSegmentValue(segement);
    }
    return (
        <>
            <IonHeader translucent={true}>
                <IonToolbar>
                    <div>
                        <div className="flex min-h-12">
                            {options.map((option, index) => (
                                <div
                                    key={index}
                                    className={`flex-1 py-3 px-4 text-center text-sm uppercase ${segmentValue === option.value ? 'text-white border-b-2 border-white font-bold' : 'text-[#9c9c9c]'}`}
                                    onClick={() => handleSegmentChange(option.value)}
                                >
                                    {option.label}
                                </div>
                            ))}
                        </div>
                    </div>
                </IonToolbar>
            </IonHeader>
        </>
    );
};

export default ToolbarSearchBarStats;
